export default __webpack_public_path__ + "static/about-1-b1ec96335d8bc4f91ad298d56a6c6272.jpg";